import { Action } from '@ngrx/store';

import { FetchFromLocalStorage } from '@digihaven/shared';

import { AuthenticationActionTypes, Login } from '@actions/authentication.actions';

import { AuthenticationState } from 'state';

export const initialState: AuthenticationState = FetchFromLocalStorage('authentication') || {
    isAuthenticated: false
};

export function authenticationReducer(state = initialState, action: Action): AuthenticationState {
    switch (action.type) {
        case AuthenticationActionTypes.Login: {
            const specificAction: Login = action as Login;
            return { ...state, isAuthenticated: true, loggedInUntil: specificAction.loggedInUntil };
        }

        case AuthenticationActionTypes.Logout: {
            return { ...state, isAuthenticated: false };
        }

        default: {
            return state;
        }
    }
}
